import { getColor } from 'utils';
import styled, { css } from 'styled-components';

export const CanvasContainer = styled('div')`
  position: relative;
  width: 100vw;
  height: 100dvh;
  overflow: hidden;
`;

export const ActionButtons = styled('div')`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 3rem;
  width: 100%;
`;

export const ActionButton = styled('div')`
  display: flex;
  position: ${props => props.position || 'relative'};
  z-index: 1;

  ${props => props.position && css`
    top: ${props.top};
    right: ${props.right};
    bottom: ${props.bottom};
    left: ${props.left};
  `}

  align-items: center;
  justify-content: center;
  width: ${props => props.width ? `${props.width}rem` : '3rem'};
  height: ${props => props.height ? `${props.height}rem` : '3rem'};
  border-radius: ${props => props.borderRadius ? `${props.borderRadius}rem` : '50%'};

  background-color: ${props => getColor(props, 'accent')};

  ${props => props.color && css`
    background-color: ${props => props.color || getColor(props, 'accent')};
  `}

  ${props => props.texture && css`
    background-image: url(${props => props.texture});
    background-repeat: no-repeat;
    background-size: cover;
  `}

  box-shadow: 0 0 0.25rem ${props => getColor(props, 'onPrimary')};
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    background-color: ${props => props.color || getColor(props, 'accentHover')};
  }
`;

export const ButtonContainer = styled('div')`
  display: inline-flex;
  gap: 0.5rem;
  width: fit-content;
`;

export const SwatchContainer = styled('div')`
  display: ${props => props.visible ? 'flex' : 'none'};
  flex-wrap: wrap;
  position: absolute;
  bottom: 5rem;
  left: 0;
  background-color: ${props => getColor(props, 'primary')};
  border: 0.09375rem solid ${props => getColor(props, 'onPrimary')};
  border-radius: 0.5rem;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-width: 7rem;
  width: 14rem;
  min-height: 3rem;
  padding: 0.5rem;
`;

export const Img = styled('img')`
  border-radius: 0.5rem;
`;

export const ColorContainer = styled('div')`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  width: auto;
`;

export const StyledIframe = styled('iframe')`
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 100dvh;
  border: none;
`;